import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, getUserId } from '../services/authorize';
import axiosInstance from "../services/axiosInterceptor";
import { useLoading } from '../contexts/LoadingContext';
import Swal from "sweetalert2";

const API = process.env.REACT_APP_API;

export default function AdvisorClassGrade() {
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  useEffect(() => {
    const yearId = localStorage.getItem('yearId');
    if (!yearId) {
      Swal.fire({ icon: 'warning', title: 'กรุณาเลือกปีการศึกษา', text: 'กรุณาเลือกปีการศึกษาก่อน' });
      navigate(-1);
      return;
    }
    setLoading(true);
    axiosInstance.get(`${API}/getRoomIdByAdvisorId/${getUserId()}/${yearId}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
    .then(res => {
      const room_id = res.data?.r_id ?? res.data;
      if (!room_id) throw new Error('ไม่พบห้องเรียน');
      navigate(`/assessment/class-grade/${room_id}/${yearId}`, { replace: true });
    })
    .catch(err => {
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: err.response?.data?.title || 'ไม่พบห้องเรียน',
        text: err.response?.data?.message || 'ยังไม่ได้รับมอบหมายเป็นครูประจำชั้นในปีการศึกษานี้',
      });
      navigate(-1);
    });
  }, []);

  return null;
}
